import { mergeLegacyAnimationEffects } from "%/dynamic-component-editor/helpers/legacy-effects-shim";

// Supplies the v-animate payload; execution lives in VCL's controller.
// The old CSS-class machinery is retired — legacy values ride the read shim.
const AnimationsMixinProduction = {
  computed: {
    animationEffects() {
      const configured = this.getOptionValue(`${this.activeState}.animation-effects`);
      return mergeLegacyAnimationEffects(key => this.getOptionValue(key), configured);
    },
  },
  methods: {
    // Kept as the pointerenter/pointerleave template bindings: hover-state
    // tracking (activeState resolution) still routes through these.
    triggerAnimation() {
      this.addPointOver();
    },
    resetAnimation() {
      this.removePointOver();
    },
  },
};

export default AnimationsMixinProduction;
